import { TableColumn } from '@vsolv/vectors/table';
import { DistributorNameCellComponent, DistributorNameCellProps } from './distributor-name-cell.component';

/** Name column with tree indent, expand toggle, and sub badge. */
export class DistributorNameColumn<I> extends TableColumn<I, DistributorNameCellProps> {
  readonly component = DistributorNameCellComponent;
}
